import React from 'react';
import BaseField, { BaseFieldProps } from '../../Inputs/BaseField/BaseField';
import ColorPicker from './ColorPicker';

const ColorPickerField: React.FC<BaseFieldProps> = props => (
	<BaseField {...props}>
		<ColorPicker />
	</BaseField>
);

export default ColorPickerField;
